<template>
  <div>
    <div class="wechart-box">
      <img src="static/footer/kefu.png" class="erweima" />
      <p>扫码添加企业微信<br>沟通更便捷</p>
    </div>
  </div>
</template>

<script>
export default {
name: "EnterpriseWechat.vue"
}
</script>

<style scoped>
.wechart-box {
  width: 137px;
  height: 179px;
  background: rgb(236,236,236);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.erweima {
  width: 119px;
  height: 120px;
}
.wechart-box p {
  text-align: center;
  font-size: 12px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/EnterpriseWechat.vue